import React from "react"
import type { SearchCategory } from "../search_hit"
import type { SearchRowComponent, SearchRowProps } from "./types"
import { ProfileRow } from "./profile_row"
import { CodexRow } from "./codex_row"
import { CollectionRow } from "./collection_row"
import { CalendarEventRow } from "./calendar_event_row"
import { LibraryRow } from "./library_row"
import { TopicRow } from "./topic_row"

// Centralised category → row-component mapping (the design-system "type-to-component" pattern). Add a
// new result type by adding its row file and one entry here.
export const ROW_COMPONENTS: Record<SearchCategory, SearchRowComponent> = {
  Codex: CodexRow,
  Profiles: ProfileRow,
  Collections: CollectionRow,
  Events: CalendarEventRow,
  Library: LibraryRow,
  Topics: TopicRow,
}

// Renders the right row for a result's category (falling back to the library row for anything
// unexpected). The dropdown groups by category, so it always knows which to ask for.
export const SearchResultRow: React.FC<SearchRowProps & { category: SearchCategory }> = ({
  category,
  ...props
}) => {
  const Row = ROW_COMPONENTS[category] ?? LibraryRow
  return <Row {...props} />
}

export { ProfileRow, CodexRow, CollectionRow, CalendarEventRow, LibraryRow, TopicRow }
export type { SearchRowProps, SearchRowComponent, SearchSelectHandler } from "./types"
